<div class="robot-service-list-container" [class.page-mode]="isPageMode" [testId]="'robot-service-list-container'">
  <div class="page-header" *ngIf="isPageMode">
    <div class="page-heading">
      <h2>{{ 'robot-service.list.page-title' | i18n }}</h2>
      <p>{{ 'robot-service.list.page-subtitle' | i18n }}</p>
    </div>
    <button nz-button nzType="primary" (click)="updateRobotService($event)" [testId]="'add-robot-button'">
      <i nz-icon nzType="plus" [testId]="'add-robot-icon'"></i>{{ 'common.add' | i18n }}
    </button>
  </div>

  <div class="action-bar" *ngIf="!isPageMode" [testId]="'action-bar'">
    <button nz-button nzType="primary" (click)="updateRobotService($event)" [testId]="'add-robot-button'">
      <i nz-icon nzType="plus" [testId]="'add-robot-icon'"></i>{{ 'common.add' | i18n }}
    </button>
  </div>

  <!-- 列表区域 -->
  <div class="list-area" [testId]="'list-area'">
    <div class="table-scroll" [testId]="'table-scroll'">
      <nz-table #robotTable [nzData]="robotList" [nzLoading]="loading" [nzFrontPagination]="false" [testId]="'robot-table'">
        <thead [testId]="'robot-table-head'">
          <tr [testId]="'robot-table-head-row'">
            <th scope="col" nzWidth="15%" [testId]="'robot-table-head-name'">{{ 'robot-service.table.name' | i18n }}</th>
            <th scope="col" nzWidth="20%" [testId]="'robot-table-head-description'">{{ 'robot-service.table.description' | i18n }}</th>
            <th scope="col" nzWidth="35%" [testId]="'robot-table-head-url'">{{ 'robot-service.table.service-url' | i18n }}</th>
            <th scope="col" nzWidth="15%" [testId]="'robot-table-head-type'">{{ 'robot-service.table.type' | i18n }}</th>
            <th scope="col" nzWidth="15%" [testId]="'robot-table-head-actions'">{{ 'common.actions' | i18n }}</th>
          </tr>
        </thead>
        <tbody [testId]="'robot-table-body'">
          <tr
            *ngFor="let robot of robotTable.data; let i = index"
            [class.selected-row]="robot.id === selectedRobotId"
            [testId]="'robot-table-row-' + i"
          >
            <td class="detail-cell" [testId]="'robot-table-cell-name-' + i">{{ robot.name }}</td>
            <td class="detail-cell" [testId]="'robot-table-cell-description-' + i">{{ robot.description }}</td>
            <td class="detail-cell url-cell" [testId]="'robot-table-cell-url-' + i">{{ robot.url }}</td>
            <td [testId]="'robot-table-cell-type-' + i">
              <nz-tag [nzColor]="getRobotTypeInfo(robot.type, robot.identityType).color" [testId]="'robot-table-type-tag-' + i">
                {{ getRobotTypeInfo(robot.type, robot.identityType).label }}
              </nz-tag>
            </td>
            <td [testId]="'robot-table-cell-actions-' + i">
              <button
                *ngIf="!isPageMode"
                nz-button
                nzType="primary"
                nzSize="small"
                nzShape="circle"
                (click)="selectRobot(robot)"
                nz-tooltip
                [nzTooltipTitle]="'robot-service.select-robot' | i18n"
                [testId]="'robot-select-button-' + i"
              >
                <i nz-icon nzType="check" [testId]="'robot-select-icon-' + i"></i>
              </button>
              <button
                nz-button
                [nzType]="isPageMode ? 'primary' : 'default'"
                nzSize="small"
                nzShape="circle"
                (click)="updateRobotService($event, robot)"
                nz-tooltip
                [nzTooltipTitle]="'common.edit' | i18n"
                [testId]="'robot-edit-button-' + i"
              >
                <i nz-icon nzType="edit" [testId]="'robot-edit-icon-' + i"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>

    <div class="mobile-robot-list" [testId]="'mobile-robot-list'">
      <article
        class="robot-card"
        *ngFor="let robot of robotList; let i = index"
        [class.selected-row]="robot.id === selectedRobotId"
        [testId]="'robot-card-' + i"
      >
        <div class="robot-card-header">
          <h3>{{ robot.name }}</h3>
          <nz-tag [nzColor]="getRobotTypeInfo(robot.type, robot.identityType).color">
            {{ getRobotTypeInfo(robot.type, robot.identityType).label }}
          </nz-tag>
        </div>
        <dl class="robot-card-fields">
          <div>
            <dt>{{ 'robot-service.table.description' | i18n }}</dt>
            <dd>{{ robot.description || '-' }}</dd>
          </div>
          <div>
            <dt>{{ 'robot-service.table.service-url' | i18n }}</dt>
            <dd class="url-cell">{{ robot.url || '-' }}</dd>
          </div>
        </dl>
        <div class="robot-card-actions">
          <button *ngIf="!isPageMode" nz-button nzType="primary" (click)="selectRobot(robot)" [testId]="'robot-card-select-button-' + i">
            <i nz-icon nzType="check"></i>{{ 'robot-service.select-robot' | i18n }}
          </button>
          <button nz-button (click)="updateRobotService($event, robot)" [testId]="'robot-card-edit-button-' + i">
            <i nz-icon nzType="edit"></i>{{ 'common.edit' | i18n }}
          </button>
        </div>
      </article>
    </div>
  </div>

  <!-- 底部按钮区域 -->
  <div class="footer-actions" *ngIf="!isPageMode" [testId]="'footer-actions'">
    <button nz-button (click)="cancel()" [testId]="'cancel-button'">{{ 'common.cancel' | i18n }}</button>
  </div>
</div>
